import { render } from "./ClientCMSRoot.vue?vue&type=template&id=33dc5f68&scoped=true"
import script from "./ClientCMSRoot.vue?vue&type=script&lang=js"
export * from "./ClientCMSRoot.vue?vue&type=script&lang=js"

import "./ClientCMSRoot.vue?vue&type=style&index=0&id=33dc5f68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dc5f68"]])

export default __exports__